import { useSection } from "../lib/useCMS";
import { PageShell } from "../components/PageShell";
import { PageHero } from "../components/page/PageHero";
import { SEO } from "../components/page/SEO";

const renderMarkdown = (md = "") => {
  // Minimal, dependency-free renderer for our static legal copy:
  // - Lines starting with "## " become h2
  // - Lines starting with "- " become bullet list items (grouped)
  // - **bold** spans become <strong>
  // - Other non-empty lines become paragraphs
  const lines = md.split("\n");
  const out = [];
  let listBuffer = [];

  const flushList = () => {
    if (!listBuffer.length) return;
    out.push(
      <ul key={`ul-${out.length}`} className="list-disc pl-6 space-y-2 text-zinc-300 my-5">
        {listBuffer.map((item, i) => (
          <li key={i} dangerouslySetInnerHTML={{ __html: boldify(item) }} />
        ))}
      </ul>
    );
    listBuffer = [];
  };

  const boldify = (s) => s.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");

  lines.forEach((raw, idx) => {
    const line = raw.trim();
    if (!line) {
      flushList();
      return;
    }
    if (line.startsWith("## ")) {
      flushList();
      out.push(
        <h2 key={`h-${idx}`} className="font-display uppercase text-2xl md:text-3xl tracking-tight mt-12 mb-4 text-white">
          {line.slice(3)}
        </h2>
      );
    } else if (line.startsWith("- ")) {
      listBuffer.push(line.slice(2));
    } else {
      flushList();
      out.push(
        <p key={`p-${idx}`} className="text-zinc-300 leading-relaxed my-4" dangerouslySetInnerHTML={{ __html: boldify(line) }} />
      );
    }
  });
  flushList();
  return out;
};

export default function LegalPage({ sectionKey, canonical }) {
  const p = useSection(sectionKey, {});

  return (
    <PageShell>
      <SEO title={p.meta_title} description={p.meta_description} canonical={canonical} />
      <PageHero overline={p.hero_overline} heading={p.hero_heading} subheading={p.hero_subheading} />

      <section className="bg-[#0a0a0a] py-16 md:py-20 border-b border-white/5">
        <div className="mx-auto max-w-[820px] px-6 md:px-10 lg:px-16">
          {p.updated_value && (
            <div className="text-[10px] tracking-[0.3em] uppercase font-bold text-brand-light mb-10">
              {(p.updated_label || "Last updated")}: {p.updated_value}
            </div>
          )}
          <article className="prose-bdh">{renderMarkdown(p.body || "")}</article>
        </div>
      </section>
    </PageShell>
  );
}
